var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[(_vm.isLoading)?_c('div',[_vm._v("\n        please wait...\n    ")]):_c('div',[(_vm.type == 'stamps')?_c('StampsComponent',{attrs:{"cKey":_vm.cKey,"pKey":_vm.pKey,"competition":_vm.competition,"test":""}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }